module.exports = __webpack_public_path__ + "images/category_lp/camera/new/main-view_f5abd9cdf6c8a2c39b0a8c67be3523da.png";